import { Component, OnInit, Input } from "@angular/core";
import { AppService } from "src/app/services/app.service";
import { Router } from "@angular/router";

@Component({
  selector: "app-manual-report",
  templateUrl: "./manual-report.page.html",
  styleUrls: ["./manual-report.page.scss"],
})
export class ManualReportPage implements OnInit {
  @Input() public reportselectedIndex: any;

  public appPages = [
    {
      title: "ค้นหารายงาน",
      url: "/report",
      action: 1,
      disabled: false,
    },
    {
      title: "รายงาน",
      url: "/report-document",
      action: 2,
      disabled: true,
    },
    {
      title: "รายละเอียด",
      url: "/report-send-document",
      action: 3,
      disabled: true,
    },
  ];

  constructor(public appservice: AppService, private router: Router) {}

  ngOnInit() {}

  clickMenu(a) {
    console.log("clickMenu...", a);
    this.reportselectedIndex = a;
    this.appservice.setActive(a);
  }

  onRouterLink(p) {
    if (p.disabled) return;
    this.router.navigate([p.url]);
  }
}
